import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { rbacApi } from "@/services/rbac";
import { PageShell, LoadingState, ErrorState } from "@/shared/ui/PageHeader";

export function PermissionsPage() {
  const perms = useQuery({ queryKey: ["rbac", "perms"], queryFn: rbacApi.listPermissions });
  const [q, setQ] = useState("");
  if (perms.isLoading) return <LoadingState />;
  if (perms.isError) return <ErrorState message="权限码加载失败" onRetry={() => perms.refetch()} />;
  const data = (perms.data ?? []).filter((p) =>
    q ? p.code.toLowerCase().includes(q.toLowerCase()) : true,
  );
  const byModule: Record<string, typeof data> = {};
  data.forEach((p) => {
    byModule[p.module] = byModule[p.module] ?? [];
    byModule[p.module].push(p);
  });

  return (
    <PageShell title="权限矩阵" subtitle={`${data.length} 权限码 · seed 来自 RBAC permissions`}>
      <input
        type="search"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="搜索权限码..."
        className="h-9 w-full max-w-md rounded-lg border border-slate-200 px-3 text-[13px]"
      />
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
        {Object.entries(byModule).map(([mod, list]) => (
          <section key={mod} className="rounded-xl border border-slate-200 bg-white p-5">
            <h3 className="mb-2 text-[14px] font-semibold text-slate-900">{mod}</h3>
            <ul className="space-y-1">
              {list.map((p) => (
                <li
                  key={p.code}
                  className="flex items-center justify-between border-b border-slate-100 py-1.5 last:border-0"
                >
                  <span className="font-mono text-[12px] text-slate-700">{p.code}</span>
                  {p.description && (
                    <span className="text-[11px] text-slate-500">{p.description}</span>
                  )}
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </PageShell>
  );
}
